import { string } from "prop-types";

const Weesp = ({ className }) => (
  <path
    d="M944 732.998V731.996L945.723 731.196L979.682 695.678L1022.4 731.273L1022.98 731.756L1023.61 731.33L1076.01 695.553L1104.62 718.22L1086.29 743.366L1085.75 744.104L1086.44 744.707L1092.58 750.087L1092.86 750.335H1093.24H1169.07V749.335V731.805L1218.93 744.92L1220.4 745.193L1220.61 744.155L1227.73 709.43L1227.8 709.051L1227.61 708.718L1209.85 678.828L1240.94 648.565L1241.67 647.856L1240.95 647.14L1227.45 633.69L1226.75 632.986L1226.04 633.69L1216.44 643.257L1187.42 614.345L1220.33 581.551L1221.24 580.65L1220.15 579.988L1093.76 503.2L1093.09 502.793L1092.53 503.346L1086.39 509.46L1085.68 510.168L1086.39 510.877L1098.69 523.129L1075.88 545.855L998.988 503.18L998.761 503.055H998.502H944.911H944V504.055V732.998Z"
    fill="url(#paint4_linear_14735_232327)"
    fillOpacity="0.25"
    stroke="#4D4D4D"
    strokeWidth="2"
    strokeMiterlimit="10"
    strokeDasharray="4 4"
    className={className}
  />
);

Weesp.propTypes = {
  className: string,
};

export default Weesp;
